import getCurrencySymbol from "./CurrencyUtils";

const CartUtils = {
  calculateCartPrice: (cart: any) => {
    return cart.reduce(
      (acc: number, item: any) =>
        acc +
        (item?.topupData &&
        item?.priceType === "fixed" &&
        item?.topupData?.estimatePrice >= 0
          ? item?.topupData?.estimatePrice
          : item.price
            ? item.price
            : 0) *
          item.quantity,
      0,
    );
  },
  getReciveValue: (cart: any): number => {
    // debugger;
    if (cart.priceType === "range") {
      return (cart?.withOutTaxTotal || 0).toFixed(2);
    }
    // const denom = cart.topupData?.receiveValue?.denomination;
    const denom = cart?.withOutTaxTotal;
    return (denom || 0).toFixed(2);
  },
  getReceiveValueFromProduct: (productItem: any, cart: any): any => {
    const currencySymbol = getCurrencySymbol(cart?.receiveCurrencyIso);

    if (cart.priceType === "range") {
      return `${currencySymbol}${cart?.receiveValue.min}-${currencySymbol}${cart?.receiveValue.max}`;
    }
    const denom = cart?.receiveValue?.denomination;
    return `${currencySymbol}${denom || 0}`;
  },
};

export default CartUtils;
